import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ColorSwatch',
  props: {
  active: {
    type: Boolean,
    default: false,
  },
  color: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const props = __props



const outerStyle = computed(() => ({
  borderColor: !props.active ? props.color : '#333',
  backgroundColor: !props.active ? props.color : 'white',
}));

const innerStyle = computed(() => ({
  backgroundColor: props.color,
}));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['color-swatch__target', {'color-swatch__target--active': __props.active}])
  }, [
    _createElementVNode("div", {
      class: "color-swatch",
      style: _normalizeStyle(_unref(outerStyle))
    }, [
      _createElementVNode("div", {
        class: "color-swatch__fill",
        style: _normalizeStyle(_unref(innerStyle))
      }, null, 4)
    ], 4)
  ], 2))
}
}

})